import { getAllowedRoleLevelsForFeature } from "utils/roleUtils";

export const routeConfig = [
  // ── 隱藏 / 系統路由 ──────────────────────────────────────────
  {
    type: "collapse",
    name: { zh: "總表", en: "Dashboard" },
    key: "tables",
    iconName: "table_view",
    route: "/tables",
    componentKey: "Tables",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("tables"),
  },
  {
    type: "collapse",
    name: "Dashboard (Place Holder)",
    key: "dashboard",
    iconName: "dashboard",
    route: "/dashboard",
    componentKey: "Dashboard",
    hidden: true,
  },
  {
    type: "collapse",
    name: "員工管理",
    key: "employeemanagement",
    iconName: "engineering",
    route: "/employeemanagement",
    componentKey: "EmployeeManagement",
    roleLevels: getAllowedRoleLevelsForFeature("employeemanagement"),
    hidden: true,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "Orders",
    iconName: "sync_alt",
    route: "/orders",
    componentKey: "Orders",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("Orders"),
  },
  {
    type: "collapse",
    name: { zh: "曝險", en: "Exposures" },
    key: "Exposures",
    iconName: "data_thresholding",
    route: "/exposures",
    componentKey: "Exposures",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("Exposures"),
  },
  {
    type: "collapse",
    name: { zh: "訂單交易", en: "Transactions" },
    key: "transactions",
    iconName: "sync_alt",
    route: "/transactions",
    componentKey: "Transactions",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("transactions"),
  },
  {
    type: "collapse",
    name: { zh: "信用額度", en: "Credits" },
    key: "Credits",
    iconName: "monetization_on",
    route: "/credits",
    componentKey: "Credits",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("Credits"),
  },
  {
    type: "collapse",
    name: "使用者管理",
    key: "usermanagement",
    iconName: "supervisor_account",
    route: "/user-management",
    componentKey: "UserManagement",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("usermanagement"),
  },
  {
    type: "collapse",
    name: "關鍵指標數據(beta)",
    key: "keymetrics",
    iconName: "bar_chart",
    route: "/keymetrics",
    componentKey: "KeyMetrics",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("keymetrics"),
  },
  {
    type: "collapse",
    name: "會員數據分析(beta)",
    key: "membershipanalysis",
    iconName: "groups",
    route: "/membershipanalysis",
    componentKey: "MembershipAnalysis",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("membershipanalysis"),
  },
  // ── 可見選單項目（依需求排序）────────────────────────────────
  {
    type: "collapse",
    name: { zh: "營運數據報表", en: "Operations Data Reports" },
    key: "marketingdataanalysis",
    iconName: "trending_up",
    route: "/marketingdataanalysis",
    componentKey: "MarketingDataAnalysis",
    roleLevels: [1, 2, 3],
  },
  {
    type: "collapse",
    name: { zh: "訂單交易", en: "Order Transactions" },
    key: "transactions-new",
    iconName: "sync_alt",
    route: "/transactions-new",
    componentKey: "TransactionsNew",
    roleLevels: getAllowedRoleLevelsForFeature("transactions-new"),
  },
  {
    type: "collapse",
    name: "異常訂單",
    key: "abnormal-orders",
    iconName: "warning_amber",
    route: "/abnormal-orders",
    componentKey: "AbnormalOrders",
    roleLevels: getAllowedRoleLevelsForFeature("abnormal-orders"),
  },
  {
    type: "collapse",
    name: { zh: "發票管理", en: "Invoice Management" },
    key: "invoices",
    iconName: "receipt",
    route: "/invoices",
    componentKey: "Invoices",
    roleLevels: getAllowedRoleLevelsForFeature("invoices"),
  },
  {
    type: "collapse",
    name: { zh: "金流請款", en: "Billing Request" },
    key: "billing-reconcile",
    iconName: "receipt_long",
    route: "/billing-reconcile",
    componentKey: "BillingReconcile",
    roleLevels: getAllowedRoleLevelsForFeature("billing-reconcile"),
  },
  {
    type: "collapse",
    name: { zh: "倉庫補貨查詢管理", en: "Warehouse Replenishment" },
    key: "warehouses",
    iconName: "warehouse",
    route: "/warehouses",
    componentKey: "Warehouses",
    roleLevels: getAllowedRoleLevelsForFeature("warehouses"),
  },
  {
    type: "collapse",
    name: { zh: "機台補貨管理", en: "Realtime Stock & Replenishment" },
    key: "warehousesRealtime",
    iconName: "inventory",
    route: "/warehouses-realtime",
    componentKey: "WarehousesRealtime",
    roleLevels: getAllowedRoleLevelsForFeature("warehousesRealtime"),
  },
  {
    type: "collapse",
    name: { zh: "商品管理", en: "Product Management" },
    key: "products",
    iconName: "inventory_2",
    route: "/products",
    componentKey: "Products",
    roleLevels: getAllowedRoleLevelsForFeature("products"),
  },
  {
    type: "collapse",
    name: { zh: "場域管理", en: "Venue Management" },
    key: "venues",
    iconName: "location_city",
    route: "/venues",
    componentKey: "Venues",
    roleLevels: getAllowedRoleLevelsForFeature("venues"),
  },
  {
    type: "collapse",
    name: { zh: "合作廠商", en: "Partners" },
    key: "manufacturer",
    iconName: "factory",
    route: "/manufacturer",
    componentKey: "Manufacturer",
    roleLevels: getAllowedRoleLevelsForFeature("manufacturer"),
  },
  {
    type: "collapse",
    name: { zh: "架構總覽", en: "Architecture Overview" },
    key: "agentmanagements",
    iconName: "account_tree",
    route: "/agentmanagements",
    componentKey: "AgentManagements",
    roleLevels: getAllowedRoleLevelsForFeature("agentmanagements"),
  },
  {
    type: "collapse",
    name: { zh: "新機台建置", en: "Machine Bootstrap Setup" },
    key: "machinebootstrapsetup",
    iconName: "precision_manufacturing",
    route: "/machine-bootstrap-setup",
    componentKey: "MachineBootstrapSetup",
    roleLevels: getAllowedRoleLevelsForFeature("machinebootstrapsetup"),
  },
  {
    type: "collapse",
    name: { zh: "裝置資訊管理", en: "Device Infos" },
    key: "deviceinfos",
    iconName: "speed",
    route: "/deviceinfos",
    componentKey: "BatteryInfos",
    roleLevels: getAllowedRoleLevelsForFeature("deviceinfos"),
  },
  {
    type: "collapse",
    name: "優惠券管理",
    key: "couponmanagement",
    iconName: "discount",
    route: "/couponmanagement",
    componentKey: "CouponManagement",
    roleLevels: getAllowedRoleLevelsForFeature("couponmanagement"),
  },
  {
    type: "collapse",
    name: "會員管理",
    key: "membershipmanagement",
    iconName: "manage_accounts",
    route: "/membershipmanagement",
    componentKey: "MembershipManagement",
    roleLevels: getAllowedRoleLevelsForFeature("membershipmanagement"),
  },
  {
    type: "collapse",
    name: "使用者管理",
    key: "usermanagement-role-editor",
    iconName: "fact_check",
    route: "/user-management-new",
    componentKey: "UserManagementRoleEditor",
    roleLevels: getAllowedRoleLevelsForFeature("usermanagement"),
  },
  {
    type: "collapse",
    name: "權限管理",
    key: "permissionmanagement",
    iconName: "admin_panel_settings",
    route: "/permission-management",
    componentKey: "PermissionManagement",
    roleLevels: getAllowedRoleLevelsForFeature("permissionmanagement"),
  },
  {
    type: "collapse",
    name: "使用者審核",
    key: "taskreview",
    iconName: "assignment_turned_in",
    route: "/task-review",
    componentKey: "TaskReview",
    roleLevels: getAllowedRoleLevelsForFeature("taskreview"),
  },
  // ── 認證路由 ─────────────────────────────────────────────────
  {
    type: "collapse",
    name: { zh: "登入", en: "Sign In" },
    key: "sign-in",
    iconName: "login",
    route: "/authentication/sign-in",
    componentKey: "SignIn",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("sign-in"),
  },
  {
    type: "collapse",
    name: { zh: "更改密碼", en: "Reset Password" },
    key: "reset-password",
    iconName: "lock_reset",
    route: "/authentication/reset-password",
    componentKey: "ResetPassword",
    roleLevels: getAllowedRoleLevelsForFeature("reset-password"),
  },
  {
    type: "collapse",
    name: { zh: "忘記密碼", en: "Forget Password" },
    key: "forget-password",
    iconName: "lock_reset",
    route: "/authentication/forget-password",
    componentKey: "ForgetPassword",
    hidden: true,
    roleLevels: getAllowedRoleLevelsForFeature("forget-password"),
  },
  {
    type: "collapse",
    name: { zh: "登出", en: "Sign Out" },
    key: "sign-out",
    iconName: "logout",
    route: "/authentication/sign-out",
    componentKey: "SignOut",
    roleLevels: getAllowedRoleLevelsForFeature("sign-out"),
  },
];

const getPermissionLabel = (name) => {
  if (typeof name === "string") return name;
  if (name && typeof name === "object") return name.zh || name.en || "";
  return "";
};

export const getSidebarPermissionItems = () =>
  routeConfig
    .filter((route) => route.type === "collapse" && !route.hidden)
    .filter((route) => Array.isArray(route.roleLevels) && route.roleLevels.length > 0)
    .map((route) => ({
      key: route.key,
      label: getPermissionLabel(route.name),
      roleLevels: route.roleLevels,
    }));
